import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SliderTirthYatra({ section }) {
    const [isScrolled, setIsScrolled] = useState(false);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4, // Show 1 slide per view
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 768, // Mobile screens
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1024, // Tablet screens
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };


    const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        setIsScrolled(scrollTop > 50);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const fallbackItems = [
        { title: 'Dwarka', image_url: 'assets/img/pilgrimage/dwarka.png', link_url: '/yatra-list' },
        { title: 'Haridwar & Rishikesh', image_url: 'assets/img/pilgrimage/haridwar-and-rishikesh.png', link_url: '/yatra-list' },
        { title: 'Kashi Vishwanath', image_url: 'assets/img/pilgrimage/kashivishwanath.png', link_url: '/yatra-list' },
        { title: 'Kumbh Mela', image_url: 'assets/img/pilgrimage/kumbh-mela.png', link_url: '/yatra-list' },
        { title: 'Puri', image_url: 'assets/img/pilgrimage/puri.png', link_url: '/yatra-list' },
        { title: 'Rameswaram', image_url: 'assets/img/pilgrimage/rameswaram.png', link_url: '/yatra-list' },
        { title: 'Shirdi', image_url: 'assets/img/pilgrimage/shirdi.png', link_url: '/yatra-list' },
        { title: 'Trimbakeshwar', image_url: 'assets/img/pilgrimage/trimbakeshwar.png', link_url: '/yatra-list' },
        { title: 'Tirupati', image_url: 'assets/img/pilgrimage/tripatism.png', link_url: '/yatra-list' },
        { title: 'Vaishno Devi', image_url: 'assets/img/pilgrimage/vaishno-devi.png', link_url: '/yatra-list' },
    ];
    const items = section?.Items?.length ? section.Items : fallbackItems;

    return (
        <div>
            <div className="container offers pb-5 " >
                <div className="popular-state pb-0 pt-0">
                    {/* <div className="container"> */}
                    <div className="title text-center ">
                        <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <><span>Explore Top Pilgrimage </span></>}{section?.title || 'Sites of India'}</h3>
                    </div>
                    <div className={`customer-logos slider airport-transfer-slide-sec pt-5 slider-width ${isScrolled ? "slide" : ""
                        }`}>
                        {/* <div className="customer-logos slider "> */}
                        <Slider {...settings}>

                            {/* <div class="customer-logos slider slides-wrapper"> */}

                            {items.map((item, index) => (
                                <div key={`${item.title}-${index}`}>
                                    <a href={item.link_url || '/yatra-list'}>
                                        <img className="br-12" src={item.image_url} alt={item.title || ''} />
                                        <div className="_offrdate pilgrimage-title">{item.title}</div>
                                    </a>
                                </div>
                            ))}

                            {/* </div> */}
                        </Slider>
                    </div>

                    {/* </div> */}
                </div>
            </div>
        </div>
    );
}

export default SliderTirthYatra;
